import React from 'react';
import Visibility from './Containers/Visibility';
import { Skeleton } from '@material-ui/lab';

const FieldLoading = ({
  isLoading,
  children,
  height = '56px',
}: {
  isLoading?: boolean;
  height?: number | string;
  children: React.ReactNode;
}) => {
  return (
    <Visibility
      isVisible={!isLoading}
      replacement={
        <Skeleton variant="rect" height={height} style={{ borderRadius: '12px' }} />
      }
    >
      {children}
    </Visibility>
  );
};

export default FieldLoading;
